import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";
import AuthLayout from "./AuthLayout";
import {
  EyeIcon,
  EyeOffIcon,
  LockIcon,
  ShieldCheckIcon,
  ShieldIcon,
  UserIcon,
} from "../../Components/Icons";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ username: "", password: "" });
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!form.username.trim()) {
      nextErrors.username = "Username or email is required";
    }
    if (!form.password) {
      nextErrors.password = "Password is required";
    }
    return nextErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const nextErrors = validate();
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    setSubmitting(true);
    // TODO: replace with the sign-in API call once the endpoint is available.
    navigate(RoutesPaths.VERIFY_OTP, {
      state: { username: form.username.trim(), remember },
    });
  };

  return (
    <AuthLayout>
      <div className="auth-card">
        <div className="auth-card__logo">
          <img
            src={`${process.env.PUBLIC_URL}/assets/DGI-logo.png`}
            alt="DGI"
          />
        </div>

        <h2 className="auth-card__title">Welcome Back</h2>
        <p className="auth-card__subtitle">
          Sign in to access the DGI Smart Tax Registry
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <div className="auth-field">
            <label className="auth-field__label" htmlFor="username">
              Username or Email
            </label>
            <div
              className={`auth-field__control${
                errors.username ? " auth-field__control--invalid" : ""
              }`}
            >
              <span className="auth-field__icon">
                <UserIcon size={18} />
              </span>
              <input
                id="username"
                name="username"
                type="text"
                className="auth-field__input"
                placeholder="Enter your username or email"
                autoComplete="username"
                value={form.username}
                onChange={handleChange}
              />
            </div>
            {errors.username && (
              <span className="auth-field__error">{errors.username}</span>
            )}
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="password">
              Password
            </label>
            <div
              className={`auth-field__control${
                errors.password ? " auth-field__control--invalid" : ""
              }`}
            >
              <span className="auth-field__icon">
                <LockIcon size={18} />
              </span>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                className="auth-field__input"
                placeholder="Enter your password"
                autoComplete="current-password"
                value={form.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="auth-field__toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
              </button>
            </div>
            {errors.password && (
              <span className="auth-field__error">{errors.password}</span>
            )}
          </div>

          <div className="auth-options">
            <label className="auth-remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(event) => setRemember(event.target.checked)}
              />
              Remember me
            </label>
            <button type="button" className="auth-link">
              Forgot Password?
            </button>
          </div>

          <button type="submit" className="auth-submit" disabled={submitting}>
            <LockIcon size={17} />
            {submitting ? "Signing In…" : "Sign In"}
          </button>
        </form>

        <div className="auth-divider">OR</div>

        <button type="button" className="auth-sso">
          <ShieldIcon size={18} />
          Sign in with Government SSO
        </button>

        <div className="auth-secure">
          <ShieldCheckIcon size={20} color="#2e9e5b" />
          <div>
            <p className="auth-secure__title">Your connection is secure</p>
            <p className="auth-secure__text">
              All data is encrypted and protected
            </p>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
